import api from "../../../api/comptabilite/_rapport_caisse";

const state = () => ({
    rapport_caisse: {}
})

// getters
const getters = {
    rapport_caisse: (state) => {
        return state.rapport_caisse;
    },
}

// mutations
const mutations = {
    SET_RAPPORT_CAISSE(state, rapport_caisse) {
        state.rapport_caisse = rapport_caisse;
    },
}

// actions
const actions = {
    getRapportCaisse({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getRapportCaisse(data).then(
                (response) => {
                    commit('SET_RAPPORT_CAISSE', response)
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
}

export default {
    state,
    getters,
    mutations,
    actions,
};